import React from 'react';
import { SearchIcon, FilterIcon } from 'lucide-react';
import { DuplicateCard, DuplicateSet } from './DuplicateCard';
import { MultiDuplicateCard } from './MultiDuplicateCard';
type DuplicateListProps = {
  duplicateSets: DuplicateSet[];
  selectedSetId: string | null;
  onSelectSet: (id: string) => void;
  searchQuery: string;
  onSearchChange: (query: string) => void;
};
export function DuplicateList({
  duplicateSets,
  selectedSetId,
  onSelectSet,
  searchQuery,
  onSearchChange
}: DuplicateListProps) {
  const filteredSets = duplicateSets.filter(set => set.primaryName.toLowerCase().includes(searchQuery.toLowerCase()) || set.secondaryName.toLowerCase().includes(searchQuery.toLowerCase()));
  return <aside className="w-full lg:w-80 xl:w-96 bg-gray-50 border-r border-gray-200 flex flex-col h-full" data-id="element-72">
      {/* Header */}
      <div className="p-4 border-b border-gray-200 bg-white" data-id="element-73">
        <h2 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-74">
          Duplicate Records
        </h2>

        {/* Search */}
        <div className="relative" data-id="element-75">
          <SearchIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" aria-hidden="true" data-id="element-76" />
          <input type="search" placeholder="Search duplicates..." value={searchQuery} onChange={e => onSearchChange(e.target.value)} className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" aria-label="Search duplicate records" data-id="element-77" />
        </div>

        {/* Stats */}
        <div className="flex items-center justify-between mt-3 text-sm text-gray-600" data-id="element-78">
          <span data-id="element-79">{filteredSets.length} duplicate sets found</span>
          <button className="flex items-center gap-1 text-blue-600 hover:text-blue-700 focus:outline-none focus:underline" aria-label="Filter duplicate sets" data-id="element-80">
            <FilterIcon className="w-4 h-4" aria-hidden="true" data-id="element-81" />
            Filter
          </button>
        </div>
      </div>

      {/* List with Custom Scrollbar */}
      <div className="flex-1 overflow-y-auto p-4 space-y-3 scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-100 hover:scrollbar-thumb-gray-500" role="list" aria-label="Duplicate record sets" style={{
      scrollbarWidth: 'thin',
      scrollbarColor: '#9CA3AF #F3F4F6'
    }} data-id="element-82">
        {filteredSets.length === 0 ? <div className="text-center py-8 text-gray-500" data-id="element-83">
            <p data-id="element-84">No duplicates found</p>
          </div> : filteredSets.map(set => set.records.length > 2 ? <MultiDuplicateCard key={set.id} duplicateSet={set} isSelected={selectedSetId === set.id} onClick={() => onSelectSet(set.id)} data-id="element-85" /> : <DuplicateCard key={set.id} duplicateSet={set} isSelected={selectedSetId === set.id} onClick={() => onSelectSet(set.id)} data-id="element-86" />)}
      </div>
    </aside>;
}